import { defineMessages } from 'react-intl';

export const bookingConfirmationViewMessages = defineMessages({
  title: {
    id: 'a1j3Pf',
    description: 'Title of the freight booking confirmation drawer',
    defaultMessage: 'Shipment Booked',
  },
  trackButton: {
    id: '94rEr/',
    description: 'Label for the track shipment button in the booking confirmation nav bar',
    defaultMessage: 'Track Shipment',
  },
  closeButton: {
    id: 'eoUyPE',
    description: 'Label for the close button in the booking confirmation drawer',
    defaultMessage: 'Close',
  },
});
